import { useState } from 'react';

const faqs = [
  {
    question: '什么是ASMR？为什么叫"耳骚"？',
    answer: 'ASMR（Autonomous Sensory Meridian Response）即自发性知觉经络反应，是一种从头皮开始向下蔓延的酥麻愉悦感。"耳骚"是我们对这种极致听觉体验的中文诠释——让耳朵在声音中"骚动"，获得难以言喻的满足感。',
  },
  {
    question: '为什么我听ASMR没有感觉？',
    answer: '大约只有20%-40%的人天生对ASMR敏感。但这不意味着你无法体验它——通过系统性的敏感度训练、选择适合自己的触发音类型、使用高品质耳机，大多数人都能逐渐感受到ASMR的愉悦。建议从轻柔的耳语或雨声开始尝试。',
  },
  {
    question: '听ASMR需要什么设备？',
    answer: '一副解析力好的耳机是基础。我们推荐使用开放式耳机获得宽广声场，或封闭式降噪耳机隔绝环境噪音。对于进阶用户，可以购买支持高解析度音频的DAC解码器，进一步提升声音细节的表现力。',
  },
  {
    question: 'ASMR对睡眠有帮助吗？',
    answer: '是的，大量研究和用户反馈都表明ASMR对改善睡眠有显著效果。ASMR能降低心率、减少压力激素分泌，帮助大脑从活跃状态过渡到放松状态。雨声、白噪音、轻柔耳语是最受欢迎的助眠ASMR类型。',
  },
  {
    question: '耳骚的内容多久更新一次？',
    answer: '我们每周更新3-5篇优质内容，涵盖ASMR音频推荐、耳机评测、声景体验和听觉技巧分享。订阅我们的Newsletter，不错过任何一篇让你耳朵上瘾的好内容。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">
            关于耳骚和ASMR，你想知道的都在这里
          </p>
        </div>
        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <span className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-300 ${
                      openIndex === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}